import Button from '@/components/Button/Button';

const ICONS = {
  'chevron-right': { style: 'fas', font: 'chevron-right', position: 'right' }
};

const ButtonPrimary = ({ children, click, classes = '', format = 'chevron-right', ...props }) => {
  return (
    <Button additionalClasses={classes} type="primary" shape="pill" icon={ICONS[format] || null} onButtonClick={click} {...props}>
      {children}&nbsp;
    </Button>
  );
};

export default ButtonPrimary;
